module.exports = "<cco-shell></cco-shell>\r\n<app-session-expiry></app-session-expiry>\r\n<app-change-password></app-change-password>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/UI/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main